import React, { useState, useEffect } from 'react';
import './Carousel.css';

const Carousel = ({ slides, interval = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
        }, interval);

        return () => clearInterval(timer);
    }, [slides.length, interval]);

    return (
        <div className="carousel-container">
            {slides.map((slide, index) => (
                (() => {
                    const slideText = typeof slide.text === 'string' ? slide.text : '';
                    const lines = slideText ? slideText.split('\n') : [];
                    return (
                <div
                    key={index}
                    className={`carousel-slide ${index === currentIndex ? 'active' : ''} ${slide.className || ''}`}
                    style={{ backgroundImage: `url(${slide.image})` }}
                >
                    <div className="carousel-overlay">
                        {lines.length > 0 && (
                            <h2 className="carousel-text">
                                {lines.map((line, i) => (
                                    <div
                                        key={i}
                                        className={line.toLowerCase().includes('apply now') ? 'carousel-cta' : ''}
                                    >
                                        {line}
                                    </div>
                                ))}
                            </h2>
                        )}
                    </div>
                </div>
                    );
                })()
            ))}
            {/* Logo Overlay */}
            {/* <img
                src={process.env.PUBLIC_URL + '/fintech_cloud_logo.svg'}
                alt="Fintech Cloud Logo"
                className="carousel-logo"
            /> */}
        </div>
    );
};

export default Carousel;
